import inputStyles from "../../../styles/UI/inputFields.module.css"
// import { ReactComponent as ClockIcon } from "../../../assets/icons/clock_black.svg";
import ColouredRoundWrapper from "../wrappers/ColouredRoundWrapper";

const TimePicker = ({
  id,
  value,
  label,
  onTimeChange,
  disabled,
  classes,
  helperText,
}: {
  id: string,
  value: string,
  label: string,
  onTimeChange: (newTime: string) => void,
  disabled?: boolean,
  classes?: string,
  helperText?: string
}) => {
  // const [open, setOpen] = useState(false) // todo: dropdown

  return (
    <label
      htmlFor={id}
      className={`flex gap-[var(--spacing-xs)] flex-col ${classes ? classes : null}`}
    >
      <span className={`pl-2 ${inputStyles.label}`}>{label}</span>
      <ColouredRoundWrapper
        bgColor="white"
        padding
        width={"100%"}
        borderColor="var(--col-border-primary)"
        classes="flex items-center"
      >
        <input
          id={id}
          className="text-[var(--col-text-primary)] focus:outline-none flex-1 min-w-0"
          type="time"
          value={value}
          disabled={disabled}
          placeholder="00:00"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            onTimeChange(event.target.value)
          }}
        />
        {/* todo: when dropdown picker is ready */}
        {/* <ClockIcon /> for dropdown later */}
      </ColouredRoundWrapper>
      {helperText && <span className="text-[var(--col-text-secondary)]">{helperText}</span>}
    </label>
  )
}

export default TimePicker